import { useEffect, useState } from 'react';
import EnvioDetalleModal from '../EnviosMetrics/components/EnvioDetalleModal';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchAlertasEnvios,
    resetAlertasEnvios,
} from '../../../../../../redux/envios';
import SkeletonAlertTable from './componentes/SkeletonAlertTable';
import { MenuItem, Select } from '@mui/material';

const TabAlertasEnvios = () => {
    const [transportista, setTransportista] = useState('all');
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.envios.isLoading);
    const alertasTab = useSelector((state) => {
        return state.envios.alertasTab;
    });
    const transportistas = useSelector((state) => {
        return state.transportistas;
    });
    const handleTransportista = (e) => {
        setTransportista(e.target.value);
        dispatch(fetchAlertasEnvios(1, e.target.value, true));
    };

    const getAlertasNewPage = (newPage) => {
        dispatch(fetchAlertasEnvios(newPage, transportista));
    };

    useEffect(() => {
        dispatch(fetchAlertasEnvios(1, transportista, true));

        return () => {
            dispatch(resetAlertasEnvios());
        };
    }, []);
    
    return (
        <>
            <div>
                {transportistas && transportistas.length > 0 && (
                    <Select
                        size="small"
                        name="transportista"
                        id="transportista"
                        onChange={handleTransportista}
                        value={transportista}
                    >
                        <MenuItem key={'transportista-0'} value={'all'}>
                            {'Todos'}
                        </MenuItem>
                        {transportistas.map((op) => (
                            <MenuItem
                                key={'transportista-' + op.id}
                                value={op.id}
                            >
                                {op.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            </div>
            <div className="tab-alertas-envios">
                {isLoading || !alertasTab ? (
                    <SkeletonAlertTable />
                ) : (
                    <EnvioDetalleModal
                        getShippingNewPage={getAlertasNewPage}
                        shippingResults={alertasTab}
                    />
                )}
            </div>
        </>
    );
};

export default TabAlertasEnvios;
